import React, {Component} from 'react';
import './assets/scss/font-icon.css';
import './App.css';
import Groups from './components/Groups/Groups';
import Header from './components/Header/Header';
import Loading from './components/Loading/Loading';
import Input from './components/Input/Input';
import groups from './groups';

class App extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            user: {},
            loading: false,
            group: false,
            groups,
            index: false
        };
    }

    enterResults = (group, index) => {
        this.setState({group, index});
    };
    closeInput = () => {
        this.setState({group: false});
    };
    nextGroup = () => {
        let next = this.state.index + 1;
        this.setState({group: groups[next]});
    };
    saveResults = results => {
        let data = this.state.groups;
        data[this.state.index].matches.map((match, index) => {
            if(results[index].score && (+results[index].score) > 0) {
                data[this.state.index].matches[index].score = results[index].score;
            }
        });
        this.setState({groups: data, group: false});
    };

    getLogin = {
        set: data => {
            console.log(data);
            if(data.name) {
                this.setState({
                    user: {
                        name: data.name,
                        email: data.email,
                        avatar: data.picture.data.url
                    },
                    loading: false
                });
            } else {
                this.setState({
                    loading: !this.state.loading
                })
            }
        },
        loading: () => {
            this.setState({
                loading: !this.state.loading
            })
        }
    };

    render() {
        return (
            <div className={this.state.loading? 'container loading': this.state.group? ' container inputActive': 'container'}>
                <div className="main-wrapper">
                    <Header getLogin={this.getLogin} user={this.state.user} />
                    <Groups getLogin={this.getLogin} groups={this.state.groups} user={this.state.user} enterResults={this.enterResults} />
                </div>
                {this.state.loading? <Loading />: ''}
                {this.state.group? <Input group={this.state.group}
                                          index={this.state.index}
                                          saveResults={this.saveResults}
                                          closeInput={this.closeInput}
                                          nextGroup={this.nextGroup}/>: ''}
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx